export const SITE = {
  brand: "Aura Bliss Reiki",
  founder: "Archana Tiwari",
  tagline: "Reiki Grand Master · 5+ years of soulful healing",
  // Placeholders — easy to update later
  phone: "+91 79858 38291",
  phoneClean: "917985838291",
  whatsappMessage: "Namaste Archana, I'd like to know more about your healing sessions.",
  email: "aurablissreiki@gmail.com",
  location: "Online sessions worldwide",
  socials: {
    instagram: "https://www.instagram.com/arcchanatwr?utm_source=qr",
    facebook: "coming-soon",
    youtube: "https://www.youtube.com/channel/UCEU8VVwbjDBaHHKp-WA1ztA",
    whatsapp: "https://wa.me/917985838291",
  },
};

export const LEARN_REIKI = {
  image: "https://customer-assets-rejwkqb3.emergentagent.net/job_aura-bliss-reiki/artifacts/d48cc7a1ffe1ca6d_Reiki%201-2.webp",
  programs: [
    {
      id: "reiki-1-2",
      name: "Reiki Level 1 + Level 2",
      tagline: "Combined learning program",
      price: "₹7,100",
      overview:
        "Start with Reiki foundations and progress into the next stage of practitioner learning.",
      about: [
        "Welcome to the transformative world of Reiki with Aura Bliss Reiki. Reiki is a Japanese energy-based practice that emphasizes relaxation, mindfulness, and the cultivation of inner balance. This combined Level 1 and Level 2 training is designed for individuals who wish to explore Reiki systematically, establish a personal practice, and develop their understanding of traditional Reiki techniques.",
        "Whether you are beginning your spiritual journey or wish to deepen your existing practice, this program offers a structured learning experience to help you approach Reiki with greater awareness, intention, and responsibility. Through guided instruction, practical techniques, and spiritual reflection, you will explore the foundations of Reiki and progress to additional practices traditionally taught at Level 2.",
      ],
      youWillExplore: [
        "Introduction to Reiki principles and practice.",
        "Foundational hand positions and self-practice.",
        "Reiki Level 2 techniques and symbols, as included in your teaching tradition.",
        "Ethical practice and guidance for continued learning.",
      ],
      levelsHeading: "What you will learn",
      levels: [
        {
          title: "Level 1 — The Foundation of Reiki",
          subtitle: "Build a foundation for your personal Reiki journey.",
          points: [
            "Introduction to Reiki, its origins, and guiding principles.",
            "Understanding Reiki practice and its place in spiritual wellness.",
            "Traditional hand positions and self-practice techniques.",
            "Exploring mindfulness, intention, and meditation.",
            "Developing a consistent personal Reiki routine.",
            "Learning responsible and respectful practice.",
          ],
        },
        {
          title: "Level 2 — Deepening Your Practice",
          subtitle: "Continue your learning with additional techniques taught in your Reiki lineage.",
          points: [
            "Introduction to traditional Reiki symbols and their intended uses within the practice.",
            "Learning the traditional techniques associated with Level 2.",
            "Exploring distance Reiki practices, if included in your lineage and curriculum.",
            "Developing focused intention and mindful practice.",
            "Understanding boundaries, consent, and ethical considerations when practising with others.",
            "Integrating Reiki into your ongoing spiritual development.",
          ],
        },
      ],
      includes: [
        "Combined Level 1 and Level 2 training.",
        "Guided instruction covering the program curriculum.",
        "Practical exercises and guidance for personal practice.",
        "Attunements appropriate to the Reiki tradition taught.",
        "Guidance on integrating Reiki into your daily spiritual routine.",
        "Certificate of completion, subject to your course and assessment requirements.",
      ],
      bookingMessage: "Namaste Archana, I'd like to enroll in the Reiki Level 1 + Level 2 program. Please share the next steps.",
      bookingLabel: "Enroll in Reiki 1+2",
    },
    {
      id: "reiki-3",
      name: "Reiki Level 3 — Advanced Practitioner",
      tagline: "Deepen Your Practice · Expand Your Awareness · Embrace Your Spiritual Growth",
      price: "₹11,000",
      overview:
        "Deepen your understanding of Reiki and explore more advanced practices within your Reiki tradition.",
      about: [
        "Welcome to the next stage of your Reiki journey with Aura Bliss Reiki. Reiki Level 3 — Advanced Practitioner Training is designed for Reiki practitioners who wish to deepen their understanding of Reiki, refine their existing practices, and explore advanced techniques within their Reiki lineage.",
        "This level encourages a more conscious approach to spiritual development, self-practice, and the responsibilities that come with working with others. Through guided learning and practical exploration, participants can continue developing their confidence, discipline, and understanding of Reiki as a complementary spiritual wellness practice.",
        "Whether you wish to strengthen your personal practice or explore the next stage of your development as a practitioner, this program offers an opportunity to build on your previous Reiki training.",
      ],
      youWillExplore: [
        "Advanced Reiki techniques and practices covered in the course.",
        "Deepening personal practice and spiritual awareness.",
        "Developing consistency, intention, and responsibility as a practitioner.",
        "Guidance for continued Reiki development.",
      ],
      levelsHeading: "What you will learn",
      levels: [
        {
          title: "Advanced Reiki Concepts",
          subtitle: "Explore advanced concepts within your Reiki tradition.",
          points: [
            "Deepen your understanding of Reiki principles and practice.",
            "Develop a more intentional and consistent approach to energy work.",
            "Reflect on the relationship between personal growth and spiritual practice.",
          ],
        },
        {
          title: "Deepening Your Personal Practice",
          subtitle: "Refine your established Reiki techniques.",
          points: [
            "Develop a regular self-practice routine.",
            "Explore meditation, intention, and mindful presence.",
            "Build greater confidence through guided exercises and reflection.",
          ],
        },
        {
          title: "Practitioner Development",
          subtitle: "Understand professional boundaries and informed consent.",
          points: [
            "Learn how to approach complementary Reiki sessions responsibly.",
            "Develop compassionate communication with clients.",
            "Understand the importance of confidentiality and ethical practice.",
          ],
        },
        {
          title: "Advanced Spiritual Growth",
          subtitle: "Explore self-awareness and personal reflection.",
          points: [
            "Strengthen your connection with your chosen spiritual practice.",
            "Cultivate patience, compassion, and consistency.",
            "Establish intentions for continued development as a Reiki practitioner.",
          ],
        },
      ],
      footnote:
        "Specific advanced symbols, techniques, and attunements will depend on the Reiki lineage and curriculum taught by Aura Bliss Reiki.",
      forWhom: {
        intro:
          "This program is intended for individuals who have an established Reiki foundation and meet the prerequisites for Level 3 training. It may be suitable for:",
        bullets: [
          "Reiki practitioners who have completed the required previous levels.",
          "Individuals wishing to deepen their personal Reiki practice.",
          "Practitioners seeking to refine their approach to complementary wellness sessions.",
          "Spiritual learners committed to continued practice and development.",
          "Individuals considering further advanced Reiki study.",
        ],
        prerequisite:
          "Completion of the required earlier Reiki levels and any lineage-specific eligibility requirements. Please confirm eligibility before enrolment.",
      },
      includes: [
        "Reiki Level 3 advanced training.",
        "Guided instruction and practical exercises.",
        "Advanced techniques and concepts covered in the program.",
        "Relevant attunement, where included in the training tradition.",
        "Guidance for continued personal practice.",
      ],
      includesNote:
        "Your training package may include the following, according to the final course curriculum:",
      bookingMessage: "Namaste Archana, I'd like to enroll in the Reiki Level 3 — Advanced Practitioner program. Please share the next steps.",
      bookingLabel: "Enroll in Reiki Level 3",
    },
    {
      id: "reiki-4",
      name: "Reiki Level 4 — Master Level",
      tagline: "Advanced mastery and development",
      price: "₹16,000",
      overview:
        "Continue your development through advanced Reiki study, deeper practice, and a greater understanding of your responsibilities as a Reiki practitioner.",
      about: [
        "Welcome to an advanced stage of your spiritual journey with Aura Bliss Reiki. Reiki Level 4 — Master Level Training is designed for experienced Reiki practitioners who are ready to deepen their understanding of Reiki, refine their established practice, and explore the responsibilities associated with advanced spiritual development.",
        "This program encourages a disciplined approach to Reiki, greater awareness of its traditional principles, and a deeper appreciation of the importance of intention, compassion, integrity, and ethical conduct.",
        "Through structured instruction and guided practice, participants can build on their previous training and continue developing their relationship with Reiki within their chosen lineage. Depending on the curriculum and tradition taught, Master Level training may also introduce advanced symbols, techniques, and further attunement practices.",
      ],
      youWillExplore: [
        "Advanced concepts and techniques within your teaching lineage.",
        "Deepening your personal Reiki practice.",
        "Developing a disciplined and ethical approach to Reiki.",
        "Further preparation for advanced study and development.",
      ],
      levelsHeading: "What you will learn",
      levels: [
        {
          title: "Advanced Reiki Principles",
          subtitle: "Deepen your understanding of Reiki philosophy and traditional practices.",
          points: [
            "Explore advanced concepts taught within your Reiki lineage.",
            "Strengthen intention, mindfulness, and consistency in practice.",
            "Reflect on the connection between personal growth and spiritual discipline.",
          ],
        },
        {
          title: "Deepening Your Personal Practice",
          subtitle: "Refine your existing Reiki techniques.",
          points: [
            "Develop a sustainable routine for personal practice.",
            "Explore meditation and self-reflection.",
            "Cultivate greater awareness, patience, and compassion.",
          ],
        },
        {
          title: "Master-Level Practitioner Development",
          subtitle: "Explore the responsibilities associated with advanced Reiki practice.",
          points: [
            "Understand consent, confidentiality, and professional boundaries.",
            "Develop thoughtful communication with people receiving Reiki sessions.",
            "Learn to approach spiritual wellness practice with humility and integrity.",
          ],
        },
        {
          title: "Master-Level Spiritual Development",
          subtitle: "Continue your personal spiritual exploration.",
          points: [
            "Strengthen your commitment to regular practice.",
            "Develop greater clarity around your spiritual intentions.",
            "Build a foundation for further advanced study within your Reiki lineage.",
          ],
        },
      ],
      forWhom: {
        heading: "Who is this program for",
        intro:
          "This program is intended for experienced Reiki practitioners who meet the prerequisites for Master Level training. It may be suitable for:",
        bullets: [
          "Practitioners who have completed the required previous Reiki levels.",
          "Individuals committed to deepening their Reiki knowledge and personal practice.",
          "Reiki practitioners seeking further advanced training.",
          "Spiritual learners who value discipline, compassion, and ethical responsibility.",
          "Eligible practitioners interested in exploring the teaching pathway, if teaching preparation is included in this course.",
        ],
        prerequisite:
          "Completion of the required earlier Reiki levels and any lineage-specific experience or eligibility requirements. Please confirm your previous training before enrolment.",
      },
      includes: [
        "Reiki Level 4 Master Level instruction.",
        "Guided learning and practical exercises.",
        "Advanced Reiki techniques and concepts included in the curriculum.",
        "Relevant Master Level attunement, where applicable to the tradition taught.",
        "Guidance for continued personal practice.",
      ],
      includesNote:
        "The program may include the following, according to the final course structure:",
      bookingMessage: "Namaste Archana, I'd like to enroll in the Reiki Level 4 — Master Level program. Please share the next steps.",
      bookingLabel: "Enroll in Reiki Level 4",
    },
    {
      id: "reiki-grand-master",
      name: "Reiki Grand Master Program",
      tagline: "Advanced spiritual development and teaching",
      price: "₹21,000",
      overview:
        "A higher-level learning journey for eligible Reiki practitioners seeking deeper study, spiritual discipline, and development within their lineage.",
      about: [
        "Welcome to an advanced stage of spiritual learning with Aura Bliss Reiki. The Reiki Grand Master Program is designed for experienced Reiki practitioners who wish to continue their spiritual development, deepen their understanding of Reiki, and explore the responsibilities involved in guiding and teaching others.",
        "This program focuses on advanced study, personal discipline, ethical practice, and the preservation of the Reiki tradition in which the practitioner has been trained.",
        "Beyond learning techniques, the Grand Master journey encourages a thoughtful approach to spiritual leadership: practising with humility, respecting individual boundaries, sharing knowledge responsibly, and supporting students through their own learning journeys.",
        "Depending on the Reiki lineage and curriculum, the program may include advanced techniques, master-level attunement practices, and preparation for teaching Reiki.",
      ],
      youWillExploreHeading: "Program focus",
      youWillExplore: [
        "Advanced Reiki study according to the course curriculum.",
        "Continued development of personal practice.",
        "Understanding the responsibilities and ethics of guiding others.",
        "Teacher development and attunement training, where included in the program.",
      ],
      levelsHeading: "What you will learn",
      levels: [
        {
          title: "Advanced Reiki Knowledge",
          subtitle: "Explore advanced principles and techniques within your Reiki lineage.",
          points: [
            "Deepen your understanding of traditional Reiki practices.",
            "Refine your approach to intention, meditation, and personal practice.",
            "Develop a more consistent and reflective relationship with Reiki.",
          ],
        },
        {
          title: "Spiritual Development & Personal Practice",
          subtitle: "Strengthen your commitment to Reiki principles.",
          points: [
            "Develop habits of self-reflection and mindful practice.",
            "Cultivate compassion, patience, humility, and integrity.",
            "Explore the role of spiritual discipline in your continuing development.",
          ],
        },
        {
          title: "Reiki Teaching & Mentorship",
          subtitle: "Explore how to structure and deliver Reiki learning sessions.",
          points: [
            "Develop clear and responsible communication with students.",
            "Learn to explain course concepts and demonstrate techniques.",
            "Understand the importance of consent, confidentiality, and appropriate professional boundaries.",
            "Explore student support, feedback, and ongoing practice guidance.",
          ],
        },
        {
          title: "Attunement & Lineage Practices",
          subtitle: "Study the attunement methods included in your Reiki tradition.",
          points: [
            "Understand the preparation and responsibilities associated with attunement ceremonies.",
            "Explore the importance of following lineage-specific teaching protocols.",
            "Learn how to communicate clearly about the nature and scope of an attunement.",
          ],
        },
        {
          title: "Ethics & Responsible Practice",
          subtitle: "Establish clear boundaries between spiritual wellness and healthcare.",
          points: [
            "Respect students' and clients' choices, consent, and confidentiality.",
            "Communicate honestly about Reiki's potential benefits and limitations.",
            "Understand the importance of continuing education and responsible teaching.",
          ],
        },
      ],
      forWhom: {
        heading: "Eligibility requirements",
        intro:
          "The Grand Master Program is intended for practitioners with substantial prior Reiki training and experience. Applicants should generally:",
        bullets: [
          "Have completed the prerequisite Reiki levels, including Master-level training required by the relevant lineage.",
          "Provide details of their previous Reiki training and certification.",
          "Have a regular personal practice and a commitment to continued learning.",
          "Demonstrate an understanding of ethical conduct and practitioner responsibilities.",
          "Meet any additional lineage-specific requirements established by Aura Bliss Reiki.",
        ],
        prerequisiteLabel: "Before enrolment",
        prerequisite:
          "Previous certificates, training history, and eligibility should be reviewed to ensure that the applicant is ready for the program. The precise prerequisites should be confirmed against the Reiki tradition and curriculum you teach.",
      },
      modulesHeading: "Program curriculum",
      modulesNote:
        "The curriculum may be organised into the following learning modules, depending on the final training structure.",
      modules: [
        {
          title: "Module 1 — Advanced Reiki Foundations",
          body: "Review advanced concepts, traditional principles, and the responsibilities associated with higher-level practice.",
        },
        {
          title: "Module 2 — Personal Practice & Spiritual Discipline",
          body: "Explore self-practice, meditation, reflection, and consistent application of the techniques taught.",
        },
        {
          title: "Module 3 — Teaching Methodology",
          body: "Learn to organise lessons, explain techniques, demonstrate practices, and support student learning, if teacher training is included.",
        },
        {
          title: "Module 4 — Attunement Training",
          body: "Study the relevant attunement procedures and their appropriate use within the practitioner's training lineage, if included.",
        },
        {
          title: "Module 5 — Ethics, Certification & Teaching Responsibilities",
          body: "Understand course standards, student assessment, accurate representation of credentials, and the scope of any teaching authorisation granted.",
        },
      ],
      bookingMessage: "Namaste Archana, I'd like to enroll in the Reiki Grand Master Program. Please share the next steps.",
      bookingLabel: "Enroll in Grand Master",
    },
  ],
};

export const ATTUNEMENTS = [
  {
    id: "samriddhi-attunement",
    name: "Samriddhi Attunement",
    subtitle: "Align Your Energy with Abundance, Prosperity & Happiness",
    mantra: "Invite Abundance. Embrace Prosperity. Align with Your Potential.",
    price: "₹2,100",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_aura-bliss-reiki/artifacts/a19e2bfea3047ac6_Samriddhi%20Attuntment.jpeg",
    description: [
      "Samriddhi Attunement is a sacred energy alignment process, similar to Shaktipat, designed to help you align your energy with abundance, prosperity, happiness, and growth.",
      "During this attunement, I will guide you through an energetic process focused on all seven chakras, with the intention of supporting a positive mindset, greater self-belief, openness to opportunities, and a healthier relationship with money and prosperity.",
      "The process is intended to help you connect with your inner potential, strengthen your sense of abundance, and become more receptive to opportunities for personal, professional, and financial growth.",
    ],
    exploreTitle: "What will you experience?",
    explore: [
      "Seven Chakra Attunement — an energy alignment process focused on all seven chakras, with an intention of inviting abundance, positivity, and prosperity into your life.",
      "Abundance & Prosperity Focus — a spiritual practice to support your intentions around financial growth, happiness, success, and new opportunities.",
      "Personalized Meditation — receive a guided meditation specifically provided as part of the attunement, which you can practise daily to stay connected with your intentions.",
      "Guidance for Daily Practice — learn how to incorporate meditation into your everyday routine to nurture a positive outlook and remain focused on your goals.",
    ],
    process: {
      heading: "How does the process work?",
      body:
        "The Samriddhi Attunement session will be conducted live over Zoom and will take approximately 60–90 minutes. During the session, I will guide you through the attunement process, focusing on your seven chakras and your intentions for abundance and prosperity. You will also receive a meditation to practise regularly as part of your spiritual journey.",
    },
    sessionDetails: {
      heading: "Samriddhi Attunement — Diwali Special",
      intro:
        "Celebrate the festive season by setting powerful intentions for abundance, happiness, prosperity, and new beginnings.",
      fields: [
        { label: "Mode", value: "Live online session via Zoom" },
        { label: "Duration", value: "Approximately 60–90 minutes" },
        { label: "Session Date", value: "One day before Diwali" },
        { label: "Date & Time", value: "Shared with registered participants via WhatsApp" },
      ],
    },
    registration: {
      heading: "How to register",
      intro: "Ready to begin your journey towards abundance and prosperity?",
      body:
        "To reserve your spot, simply tap the WhatsApp button below and send a message. Once you register, I will confirm the session date and timing with you directly.",
      outro:
        "Let this Diwali be an opportunity to reconnect with your inner potential, nurture an abundance-oriented mindset, and welcome new possibilities into your life.",
    },
    bookingMessage: "Namaste Archana, I'd like to book the Samriddhi Attunement. Please share the next steps.",
    bookingLabel: "Book Samriddhi Attunement",
  },
  {
    id: "vidya-attunement",
    name: "Vidya Attunement",
    subtitle: "A spiritual offering for students and learners",
    price: "₹2,100",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_aura-bliss-reiki/artifacts/1d07dd8d7c3b4601_Education.jpeg",
    description:
      "A supportive spiritual practice for students who wish to approach their studies with greater calmness, focus, confidence, and positive intention.",
    explore: [
      "Developing a calm and focused approach to studying.",
      "Encouraging confidence before examinations.",
      "Supporting positive intentions around learning and knowledge.",
      "Creating a peaceful study routine through mindfulness and spiritual practice.",
      "Building motivation, discipline, and a positive attitude toward academic goals.",
    ],
    forWhom:
      "School students, college students, competitive exam aspirants, and lifelong learners seeking a spiritual practice alongside their regular studies.",
    bookingMessage: "Namaste Archana, I'd like to book the Vidya Attunement. Please share the next steps.",
    bookingLabel: "Book Vidya Attunement",
  },
  {
    id: "health-attunement",
    name: "Health Attunement",
    subtitle: "For peace, relaxation and emotional well-being",
    price: "₹3,100",
    exchangeLabel: "Energy Exchange",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_aura-bliss-reiki/artifacts/ac060605b6e37f2a_Health%20Attuntment.webp",
    description:
      "A spiritual wellness offering for individuals who wish to bring more calmness, self-care, and positive intention into their wellness journey.",
    exploreTitle: "Potential areas of personal support",
    explore: [
      "Encouraging relaxation and a sense of inner peace.",
      "Supporting mindfulness and emotional self-care.",
      "Developing a positive daily wellness routine.",
      "Making time for reflection, meditation, and spiritual connection.",
      "Complementing a person's broader approach to well-being.",
    ],
    forWhom:
      "Individuals experiencing stress, emotional overwhelm, or ongoing health challenges who wish to explore Reiki as a complementary spiritual wellness practice.",
    bookingMessage: "Namaste Archana, I'd like to book the Health Attunement. Please share the next steps.",
    bookingLabel: "Book Health Attunement",
  },
];

export const SHOP_ITEMS = [
  {
    id: "samriddhi-box",
    name: "Aura Bliss Samriddhi Box",
    tagline: "Diwali Launch Offer",
    price: "₹2,000",
    description:
      "A curated festive box of blessings — a sacred bundle to invite abundance, protection and auspicious energy into your home this Diwali.",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_aura-bliss-reiki/artifacts/0506130164853e8d_Samriddhi.jpeg",
    highlights: ["Festive gift box", "Hand-blessed", "Limited Diwali edition"],
  },
  {
    id: "prosperity-potli",
    name: "Prosperity Crystal Potli",
    tagline: "Festive Blessing",
    price: "₹1,500",
    description:
      "A festive potli containing selected crystals, a small intention card, and gentle instructions for personal reflection and ritual use.",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_aura-bliss-reiki/artifacts/cc0f3b062489fea3_Properity%20Kit.jpeg",
    highlights: ["Curated crystals", "Intention card", "Ritual guide"],
  },
  {
    id: "seven-chakras-kit",
    name: "Seven Chakras Healing Kit",
    tagline: "Daily Practice Set",
    price: "₹2,000",
    description:
      "A set of seven chakra stones, a chakra guide, daily affirmations, and a short guided meditation personally recorded by Archana.",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_aura-bliss-reiki/artifacts/cb70e89be66b7290_7%20Chakra.jpeg",
    highlights: ["7 chakra stones", "Chakra guide", "Guided meditation"],
  },
];

export const SERVICES = [
  {
    id: "reiki",
    name: "Reiki Healing",
    duration: "1 session",
    price: "₹500",
    description:
      "Channelled universal life-force energy to release stress, restore balance, and gently reset your nervous system.",
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773",
    benefits: ["Deep relaxation", "Emotional release", "Chakra alignment"],
  },
  {
    id: "21-day-healing",
    name: "21-Day Distance Healing",
    duration: "21 days",
    price: "₹2,100",
    description:
      "A focused 21-day distance healing program for any concern — relationships, marriage, finances, health or recurring life patterns.",
    image: "https://images.pexels.com/photos/35654885/pexels-photo-35654885.jpeg",
    benefits: ["Targeted healing", "Daily energy work", "Lasting shift"],
  },
  {
    id: "reiki-lamp",
    name: "Reiki Lamp Healing",
    duration: "21 days",
    price: "₹4,100",
    description:
      "A powerful 21-day Reiki Lamp healing — a sacred flame continuously charged with Reiki energy, working deeply on your intention day and night.",
    image: "https://images.unsplash.com/photo-1518199266791-5375a83190b7",
    benefits: ["Continuous energy", "Deep intention work", "Sacred flame"],
  },
  {
    id: "past-life",
    name: "Past Life Regression",
    duration: "1 session",
    price: "₹2,100",
    description:
      "A safe, guided journey into past lifetimes to dissolve recurring patterns, fears and karmic ties at their root.",
    image: "https://images.unsplash.com/photo-1570506097811-83004c7e4691",
    benefits: ["Pattern release", "Karmic clarity", "Soul-level insight"],
  },
  {
    id: "past-life-healing",
    name: "Past Life Regression + Healing",
    duration: "Extended session",
    price: "₹4,000",
    description:
      "A deeper journey combining past life regression with focused energy healing — for full release and integration in one immersive session.",
    image: "https://images.unsplash.com/photo-1517502884422-41eaead166d4",
    benefits: ["Regression + Reiki", "Deep release", "Holistic closure"],
  },
  {
    id: "crystal",
    name: "Crystal Healing",
    duration: "1 session",
    price: "₹500",
    description:
      "Intuitively placed crystals work with your energetic field to cleanse, protect and recalibrate each chakra.",
    image: "https://images.pexels.com/photos/6998592/pexels-photo-6998592.jpeg",
    benefits: ["Chakra cleansing", "Aura strengthening", "Emotional grounding"],
  },
  {
    id: "crystal-21",
    name: "21-Day Crystal Healing",
    duration: "21 days",
    price: "₹2,600",
    description:
      "An extended 21-day crystal healing program — layered crystal grids held in sacred intention to deeply cleanse, protect and realign your energy over three full weeks.",
    image: "https://images.unsplash.com/photo-1518176258769-f227c798150e",
    benefits: ["Sustained healing", "Deep aura work", "Chakra reset"],
  },
  {
    id: "astrology-topic",
    name: "Astrology Reading — One Topic",
    duration: "Focused reading",
    price: "₹1,500",
    description:
      "An in-depth astrological reading focused on one specific area of your life — career, love, finances, health or a key decision.",
    image: "https://images.unsplash.com/photo-1532968961962-8a0cb3a2d4f5",
    benefits: ["Focused clarity", "Cosmic timing", "Actionable insight"],
  },
  {
    id: "astrology-full",
    name: "Astrology Reading — Full Chart",
    duration: "Comprehensive",
    price: "₹3,000",
    description:
      "A complete birth chart reading covering every life area — your soul blueprint, dharma, relationships, finances, health and life purpose.",
    image: "https://images.unsplash.com/photo-1543722530-d2c3201371e7",
    benefits: ["Complete chart", "Life roadmap", "Soul purpose"],
  },
];

export const TESTIMONIALS = [
  {
    name: "Priya S.",
    location: "Mumbai",
    quote:
      "Archana's Reiki session was the deepest peace I've felt in years. I walked out lighter, clearer, and finally able to breathe.",
  },
  {
    name: "Rohan M.",
    location: "Bengaluru",
    quote:
      "The past life regression revealed exactly what I needed to release. Three months later, the patterns truly don't have a grip on me.",
  },
  {
    name: "Anika G.",
    location: "Delhi",
    quote:
      "Her crystal healing felt sacred and gentle at once. I keep returning — Aura Bliss is my sanctuary.",
  },
  {
    name: "Meera K.",
    location: "Pune",
    quote:
      "Archana holds space like no one else. Her guidance is grounded, intuitive and deeply heart-led.",
  },
];

export const FAQS = [
  {
    q: "I've never tried Reiki — what should I expect?",
    a: "You'll lie down fully clothed in a calm, candlelit space. I'll place my hands on or just above your body in a series of positions. Most clients drift into a deeply relaxed, almost meditative state. There's nothing you need to do except receive.",
  },
  {
    q: "Are sessions available online?",
    a: "All sessions are conducted online via video call. Energy is not bound by distance — online Reiki, regression, crystal healing and astrology readings are equally powerful, and you receive the healing in the comfort of your home.",
  },
  {
    q: "How many sessions will I need?",
    a: "Many clients feel meaningful shifts after a single session. For deeper or long-standing issues I usually recommend a series of 3–6 sessions, spaced 1–2 weeks apart.",
  },
  {
    q: "Is past life regression safe?",
    a: "Absolutely. You remain conscious and in control throughout. I guide you gently, and we never visit anything you're not ready for. The process is held with deep care.",
  },
  {
    q: "How do I pay and book?",
    a: "Send me a message via the form or WhatsApp. I'll reply with available slots and a secure payment link. UPI and online payments are accepted.",
  },
];
